import React from 'react';
import { FilledIconContainer, IconContainer } from 'theming/tokens/components/icon';
const QuestionIcon = props => {
  const isSmall = ['small', 'xs'].includes(props.size ?? '');
  if (props.variant === 'filled' || isSmall) {
    return /*#__PURE__*/React.createElement(FilledIconContainer, {
      fill: props.fill,
      size: props.size
    }, /*#__PURE__*/React.createElement("path", {
      d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,168a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.72V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36s40,16.15,40,36C168,125.38,154.24,139.93,136,143.28Z"
    }));
  }
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("circle", {
    cx: "128",
    cy: "180",
    r: "6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,144v-8c17.67,0,32-12.54,32-28s-14.33-28-32-28S96,92.54,96,108v4",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "128",
    cy: "128",
    r: "96",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }));
};
export { QuestionIcon };